import { useEffect, useState } from 'react';
import fastpanel from '../utils/fastpanel';

const useModalToggleTracking = (isOpen: boolean, tracking: any) => {
  const [wasOpen, setWasOpen] = useState(false);

  useEffect(() => {
    if (isOpen !== wasOpen) {
      if (isOpen) {
        fastpanel({ name: 'pbr_modal_opened', data: tracking });
      } else {
        fastpanel({ name: 'pbr_modal_closed', data: tracking });
      }

      setWasOpen(isOpen);
    }
  }, [isOpen, wasOpen, tracking]);
};

export default useModalToggleTracking;
